import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Converts 24-hour time format to 12-hour format with AM/PM
 * @param time - Time string in HH:mm or HH:mm:ss format (e.g., "14:00" or "14:00:00")
 * @returns Formatted time string (e.g., "2:00 PM")
 */
export function formatTime(time: string | null | undefined): string {
  if (!time) return "";
  
  const [hours, minutes] = time.split(":").map(Number);
  const period = hours >= 12 ? "PM" : "AM";
  const displayHours = hours % 12 || 12;
  
  return `${displayHours}:${minutes.toString().padStart(2, "0")} ${period}`;
}
